import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUpload = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M6.48427 11.9609C3.7693 12.5336 1.75 14.6983 1.75 17.2814C1.75 20.3017 4.51073 22.7501 7.91626 22.7501C8.50045 22.7501 9.06565 22.6781 9.60119 22.5434",
			stroke: "#2B2B2B",
			strokeWidth: 1.1,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.5154 11.9609C24.2304 12.5336 26.2496 14.6983 26.2496 17.2814C26.2496 20.3017 23.4889 22.7501 20.0834 22.7501C19.4992 22.7501 18.934 22.6781 18.3984 22.5434",
			stroke: "#2B2B2B",
			strokeWidth: 1.1,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.4826 11.8124C21.4826 8.1881 18.1697 5.25 14.0831 5.25C9.99648 5.25 6.68359 8.1881 6.68359 11.8124",
			stroke: "#2B2B2B",
			strokeWidth: 1.1,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.80664 16.1231L14.0826 12.3184L18.4803 16.1882",
			stroke: "#2B2B2B",
			strokeWidth: 1.1,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.082 20.5598V13.1562",
			stroke: "#2B2B2B",
			strokeWidth: 1.1,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgUpload;
